function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M179.856,91.57H184.7l7.383,12.847h.3l7.381-12.847h4.844l-10.252,17.164v11.1h-4.251v-11.1Z",
  transform: "translate(-179.856 -91.184)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M221.85,105.906a16.931,16.931,0,0,1-1.656,7.778,12.1,12.1,0,0,1-4.533,4.993,13.118,13.118,0,0,1-13.08,0,12.109,12.109,0,0,1-4.533-5,19.071,19.071,0,0,1,0-15.545,12.11,12.11,0,0,1,4.533-5,13.118,13.118,0,0,1,13.08,0,12.1,12.1,0,0,1,4.533,5A16.919,16.919,0,0,1,221.85,105.906Zm-4.222,0a13.63,13.63,0,0,0-1.11-5.813,8.261,8.261,0,0,0-3.035-3.588,8.368,8.368,0,0,0-8.715,0,8.264,8.264,0,0,0-3.029,3.588,15.761,15.761,0,0,0,0,11.629,8.27,8.27,0,0,0,3.029,3.59,8.393,8.393,0,0,0,8.715,0,8.267,8.267,0,0,0,3.035-3.59A13.627,13.627,0,0,0,217.627,105.906Z",
  transform: "translate(-160.696 -91.391)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M233.114,91.57h4.276v18.589A9.854,9.854,0,0,1,236,115.407a9.667,9.667,0,0,1-3.92,3.588,14.037,14.037,0,0,1-11.825,0,9.669,9.669,0,0,1-3.916-3.588,9.855,9.855,0,0,1-1.395-5.248V91.57h4.263v18.241a6.763,6.763,0,0,0,.848,3.409,6.006,6.006,0,0,0,2.407,2.338,8.511,8.511,0,0,0,7.417,0,5.9,5.9,0,0,0,2.4-2.338,6.847,6.847,0,0,0,.835-3.409Z",
  transform: "translate(-139.201 -91.184)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M232.52,119.83V91.57h10.073A11.731,11.731,0,0,1,248.05,92.7a7.508,7.508,0,0,1,3.249,3.124,9.523,9.523,0,0,1,1.077,4.6,9.277,9.277,0,0,1-1.084,4.559,7.372,7.372,0,0,1-3.255,3.057,12.114,12.114,0,0,1-5.457,1.09h-7.631v-3.67h7.245a8.213,8.213,0,0,0,3.374-.594,3.941,3.941,0,0,0,1.91-1.725,5.685,5.685,0,0,0,.607-2.718,5.9,5.9,0,0,0-.615-2.774,4.077,4.077,0,0,0-1.917-1.8,7.916,7.916,0,0,0-3.415-.628h-5.354v24.6Zm13.95-12.749,6.981,12.749h-4.857l-6.843-12.749Z",
  transform: "translate(-118.833 -91.184)",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M263.965,119.83l-8.087-28.26H262.4l4.678,19.636h.235l5.159-19.636h5.589l5.148,19.677h.248l4.676-19.677h6.528l-8.087,28.26h-5.822l-5.382-18.476h-.22l-5.369,18.476Z",
  transform: "translate(-255.878 -91.184)",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M305.125,105.906a16.373,16.373,0,0,1-1.746,7.866,12.175,12.175,0,0,1-4.745,4.948,14.209,14.209,0,0,1-13.5-.006,12.223,12.223,0,0,1-4.734-4.954,18.634,18.634,0,0,1,0-15.715,12.152,12.152,0,0,1,4.734-4.948,14.217,14.217,0,0,1,13.5,0,12.161,12.161,0,0,1,4.745,4.948A16.355,16.355,0,0,1,305.125,105.906Zm-6.057,0a12.706,12.706,0,0,0-.889-5.049,6.88,6.88,0,0,0-2.5-3.117,7.261,7.261,0,0,0-7.562,0,6.854,6.854,0,0,0-2.5,3.117,14.751,14.751,0,0,0,0,10.1,6.854,6.854,0,0,0,2.5,3.117,7.261,7.261,0,0,0,7.562,0,6.88,6.88,0,0,0,2.5-3.117A12.71,12.71,0,0,0,299.068,105.906Z",
  transform: "translate(-229.481 -91.391)",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M313.086,99.9a3.49,3.49,0,0,0-1.42-2.593,5.629,5.629,0,0,0-3.411-.926,6.643,6.643,0,0,0-2.47.406,3.47,3.47,0,0,0-1.537,1.127,2.657,2.657,0,0,0-.533,1.628,2.294,2.294,0,0,0,.326,1.323,3.172,3.172,0,0,0,.974.974,6.817,6.817,0,0,0,1.433.7,14.321,14.321,0,0,0,1.74.505l2.539.607a17.769,17.769,0,0,1,3.393,1.1,10.354,10.354,0,0,1,2.679,1.7,7.116,7.116,0,0,1,1.757,2.375,7.546,7.546,0,0,1,.641,3.132,7.792,7.792,0,0,1-1.317,4.49,8.393,8.393,0,0,1-3.752,2.94,15.076,15.076,0,0,1-5.9,1.043,15.5,15.5,0,0,1-5.956-1.051,8.664,8.664,0,0,1-3.946-3.111,9.236,9.236,0,0,1-1.483-5.112h5.783a4.25,4.25,0,0,0,.82,2.366,4.423,4.423,0,0,0,1.945,1.423,7.577,7.577,0,0,0,2.767.475,7.177,7.177,0,0,0,2.642-.443,4.042,4.042,0,0,0,1.746-1.226,2.85,2.85,0,0,0,.62-1.809,2.368,2.368,0,0,0-.557-1.6,4.376,4.376,0,0,0-1.63-1.105,16.72,16.72,0,0,0-2.614-.827l-3.078-.773a12.906,12.906,0,0,1-5.643-2.718,6.3,6.3,0,0,1-2.055-4.982,7.369,7.369,0,0,1,1.373-4.484,9.178,9.178,0,0,1,3.814-3,13.5,13.5,0,0,1,5.52-1.075,13.123,13.123,0,0,1,5.5,1.075,8.723,8.723,0,0,1,3.663,3,7.925,7.925,0,0,1,1.353,4.443Z",
  transform: "translate(-208.41 -91.391)",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M313.355,119.83V91.57h5.975v11.661h12.128V91.57h5.962v28.26h-5.962V108.158H319.33V119.83Z",
  transform: "translate(-189.279 -91.184)",
  fill: "#fff"
});

function SvgLogoW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312.251,
    height: 29.117,
    viewBox: "0 0 312.251 29.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-179.856 -91.391)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.856 91.391)",
    style: {
      isolation: "isolate"
    }
  }, _ref2, _ref3, _ref4, _ref5), /*#__PURE__*/React.createElement("g", {
    transform: "translate(343.966 91.391)",
    style: {
      isolation: "isolate"
    }
  }, _ref6, _ref7, _ref8, _ref9)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoW);
export default __webpack_public_path__ + "static/media/logo_w.4b7282e6d2f549dd978682e7cc919d50.svg";
export { ForwardRef as ReactComponent };